type AnyFn = (...args: any[]) => Promise<any>;

function delayPromise<T extends AnyFn>(requestFn: T, minTime: number): T {
  return (async (...args: Parameters<T>): Promise<Awaited<ReturnType<T>>> => {
    const [response] = await Promise.all([
      requestFn(...args),
      new Promise((resolve) => setTimeout(resolve, minTime)),
    ]);
    return response;
  }) as T;
}

export default delayPromise;
